<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
            <div class="m-box">
              <p class="w-subtitle" style="text-align:right">{{ translate("general information") }}</p>
              <b-form autocomplete="off">
                <b-form-group style="text-align:left">
                  <label class="w-label w-required" for="input-name">{{ translate("winery name") }}</label>
                  <b-form-input
                  id="input-name"
                  class="w-input"
                  v-model="form.name"
                  v-bind:class="{'form-control':true, 'is-invalid' : !this.nameValid}"
                  aria-describedby="input-live-help input-live-feedback"
                  placeholder="Enter winery name"
                  @input="changeWebname"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-live-feedback">
                    {{nameFeedback}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group style="text-align:left">
                  <label class="w-label" for="input-description">{{ translate("winery description") }}</label>
                  <b-form-textarea
                    id="input-description"
                    class="w-textarea-big"
                    v-model="form.description"
                    placeholder="Enter winery description"
                    rows="10"
                    max-rows="15"
                  ></b-form-textarea>
                </b-form-group>
              </b-form>
            </div>
            <div class="m-box">
              <b-button v-on:click="onNext()" class="w-button-green-full">{{ translate("next") }}</b-button>
            </div>
          </b-col>
        </b-row>
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>  
        </b-sidebar>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>

    <b-modal id="Warning" size="md" @ok="switch2ProfileLanguage" @cancel="changeProfileanguage">
      <template #modal-header>
        <div>
          <font-awesome-icon 
          id="warning"
          class="w-cursor-click" 
          style="font-size:24px;display:inline-block" 
          icon="exclamation-triangle"
          color="rgb(195,147,130)" 
        />
        <p style="display:inline-block; margin-bottom:0; font-size:24px; font-weight:bold; color:rgb(195,147,130)">&nbsp warning</p>       
        </div>
      </template>

      <p class="w-subtitle"> {{ translate_language("Your chosen language is",this.currentLanguage) }} <b>{{ getLanguageName(currentLanguage) }}</b>, {{translate_language("while your profile language is",user.language) }} <b>{{ getLanguageName(currentUser.language) }}.</b></p>
      <p class="w-subtitle"> {{ translate_language("Option 1: Shall I switch over to your profile language and continue in", user.language) }} <span style="color:rgb(109,122,82)"><b>{{ getLanguageName(user.language) }}</b></span>?</p>
      <p class="w-subtitle"> {{ translate("Option 2: Shall I change your profile language to") }} <span style="color:rgb(195,147,130)"><b>{{ getLanguageName(currentLanguage) }}</b></span > {{ translate("and continue in")}} <span style="color:rgb(195,147,130)"> <b>{{ getLanguageName(currentLanguage) }}</b></span>?</p>
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">  
          <b-col class="text-left" style="padding:0">
            <b-button class="w-button-pink" @click="cancel()">
              {{ getLanguageName(currentLanguage) }}
            </b-button>
          </b-col>
          <b-col class="text-right" style="padding:0">
            <b-button class="w-button-green" @click="ok()">
              {{ getLanguageName(user.language) }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>      
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import makeWebname from '../assets/js/makeWebname.js';
  import Winery_from_Webname from '../Winery_from_Webname.js';

  import NoAccess from './NoAccess.vue'
  import Menu from './MenuMobile.vue'

  import Users from '../Users.js'
  import Wineries from '../Wineries.js'

  export default {
    name: 'WineryGeneral',
    components: {
      NoAccess,
      Menu
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },      
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },          
      previousPage() {
        return this.$store.state.previous_page
      }
    },
    data() {
      return {
        debug: false,

        isLoading: true,

        form: {
          name : '',
          description: '',
          webname: '',
          wine_ids:[]
        },
        winery_id:0,

        user:{},
        user_id:0,

        nameValid : true,
        nameFeedback : '',
        isValid : false,
      }
    }, 
    async mounted() {
      let local_debug = false
      if (local_debug || this.debug) console.log("WineryGeneral.mounted: Fetching winery from DB ", this.$route.query.winery_id);

      this.user_id = this.currentUserID;
      this.user = this.currentUser;

      // console.log("TMP this.previousPage = ", this.previousPage)
      // console.log("TMP this.currentLanguage = ", this.currentLanguage)
      // console.log("TMP this.user.language = ", this.user.language)
      
      if ( this.previousPage == 'Welcome' && this.currentLanguage != this.user.language ) {
        this.$root.$emit("bv::show::modal", "Warning");
      }

      await Wineries.getone(this.$route.query.winery_id)
      .then(response=>{
        if (typeof response == "object") {
          this.form = response;
          this.winery_id = response._id;
          delete this.form._id;
          if (local_debug || this.debug) console.log("WineryGeneral.mounted: Winery ", this.form.name, " succesfully fetched from DB");
        } else {
          if (local_debug || this.debug) console.log("WineryGeneral.mounted: Winery with ID ", this.$route.query.winery_id, " does NOT exist.");
          alert("WineryGeneral.mounted: Winery with ID "+ this.$route.query.winery_id + " does NOT exist. Login off.");
          this.$store.commit('logout')
          this.$router.push({path:'/'})
        }
      })
      .catch(error=>{
        if (local_debug || this.debug) console.log("WineryGeneral.mounted: catch await Wineries.getone - ERROR : ", error);
      })

      this.isLoading = false
    },
    methods: {
      validate(){
        if( this.form.name.length >= 3) {
            this.nameValid = true;
        } else {
            this.nameValid = false
            this.nameFeedback = "winery name should at least be 3 characters long"
        }
        this.isValid = this.nameValid;
      },  
      async onSave() {
        this.validate();
        if(this.isValid){
          await Wineries.update(this.$route.query.winery_id,this.form)
          .then(response => {
             if (this.debug) console.log("WineryGeneral .onSave: Submitted - ", response)
             return 'done'
          })
          .catch(error => {
            if (this.debug) console.log("WineryGeneral .onSave: catch await Winerues.update - ", error)
            return 'error'
          })
        }
      },
      async onNext() {
        await this.onSave()
        .then(response=>{
          if (this.debug) console.log("WineryGeneral.onNext():", response)
          this.$store.commit('setPage','Contact')
          this.$router.push({path:'/Winery/Contact', query: {winery_id:this.$route.query.winery_id }} );
        })
      },
      onReset() {
          this.form.name = '';
          this.form.description = '';
          this.form.webpage = '';
      },

      async changeWebname() {
        let doSearch = true;
        let i = 0;
        let root_webname = makeWebname(this.form.name)
        let try_webname = root_webname

        while (doSearch) {
          if (this.debug) console.log("WineryGeneral.changeWebname: trying ", try_webname);
          let challenge = {"webname": try_webname};
          await Winery_from_Webname.getToken(challenge)
          .then(response => {
            if (response === 0) {
              if (this.debug) console.log("WineWineryGeneral.changeWebname: winery with webname ", try_webname, " has no id and does NOT exists in DB");
              doSearch = false;
            } else {
              if (this.debug) console.log("WineWineryGeneral.changeWebname: winery with webname ", try_webname, " has id = ", response, " and exists in DB");
              if (response != this.winery_id) {
                doSearch = true;
                i++;
                try_webname = root_webname + '_' + i
              } else {
                if (this.debug) console.log("WineWineryGeneral.changeWebname: winery remains the same.")
                doSearch = false;
              }
            }
          })
          .catch(error => {
            doSearch = true;
            if (this.debug) console.log("WineWineryGeneral.changeWebname: await Winery_from_Webname.getToken - ", error);
          })
        }

        this.form.webname = try_webname
        
        if (this.debug) console.log("WineWineryGeneral.changeWebname: webname ", try_webname, " will be used.");
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("WineWineryGeneral.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("WineWineryGeneral.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('WineWineryGeneral.selectLanguage: catch await Users.update ERROR : ', error);
      })

        if (local_debug || this.debug) console.log("WineWineryGeneral.selectLanguage: STOP");
      },

      async switch2ProfileLanguage() {
        let local_debug = false

        if (local_debug || this.debug) console.log("WineryGeneral.switch2ProfileLanguage : START")
        this.$store.commit('setLanguage',this.user.language) 

        if (local_debug || this.debug) console.log("WineryGeneral.switch2ProfileLanguage : STOP")
 
      },

      async changeProfileanguage() {
        let local_debug = false

        if (local_debug || this.debug) console.log("WineryGeneral.changeProfileanguage : START")
        
        if (local_debug || this.debug) console.log("WineryGeneral.changeProfileanguage : changing profile language from ", this.user.language , " to ", this.currentLanguage)
        this.user.language = this.currentLanguage
        await Users.update(this.user_id,this.user)
          .then(response => {
            if (local_debug || this.debug) console.log("WineryGeneral.changeProfileanguage : User ", response , " succesfully updated!")
          })
          .catch(error => {
            if (local_debug || this.debug) console.log("WineryGeneral.changeProfileanguage : Catch is await Users error:", error)
          })
        
        if (local_debug || this.debug) console.log("WineryGeneral.changeProfileanguage : STOP")
      },

      translate(string) {
        return translate_word(string, this.currentLanguage);
      }, 

      translate_language(string, language) {
        if (string == "Option 2: Shall I change your profile language to") console.log("TMP - ", language)
        return translate_word(string, language);
      },

      getLanguageName(code) {
        const languages = {
            "en": "English",
            "fr": "Français",
            "de": "Deutsch",
            "es": "Español",
            "it": "Italiano",
            "pt": "Português",
            "nl": "Nederlands",
            "ru": "Русский",
            "zh": "中文",
            "ja": "日本語",
            "ko": "한국어",
            "ar": "العربية",
            "hi": "हिन्दी"
        };
        return languages[code] || "Unknown Language"
      }            
    }
  }
</script>

<style scoped>
</style>